import { createSlice } from '@reduxjs/toolkit'

export default createSlice({
  name: 'event',
  initialState: null,
  reducers: {
    setEvent: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
})
